export default "__VITE_ASSET__MTwkRofm__"